<script lang="ts">
export default {
    name: 'BasePopupClose',
};
</script>

<script setup lang="ts">
interface Props {
    fill: string;
}

const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
    <svg class="icon-close" width="28" height="28" viewBox="0 0 28 28" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-expect-error -->
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 27.75c7.594 0 13.75-6.156 13.75-13.75S21.594.25 14 .25.25 6.406.25 14 6.406 27.75 14 27.75Zm2.828-17.993a1 1 0 0 1 1.414 1.414L15.414 14l2.828 2.828a1 1 0 0 1-1.414 1.414l-2.829-2.828-2.828 2.828a1 1 0 0 1-1.414-1.414L12.585 14 9.757 11.17a1 1 0 0 1 1.414-1.414L14 12.585l2.828-2.828Z"
            fill-opacity=".5"
        />
    </svg>
</template>

<style lang="scss" scoped>
.icon-close {
    width: 28px;
    height: 28px;
}
</style>
